import { TrendingUp, TrendingDown } from "lucide-react";
import { Card } from "@/components/ui/card";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const fmtBRL = (v) =>
  Number(v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const COLORS = {
  "Renda Variável": "#8B5CF6",
  "Renda Fixa": "#06B6D4",
  Cripto: "#F59E0B",
  Outros: "#94A3B8",
};

export default function InvestmentOverviewCard({ data }) {
  const byClass = data?.by_class || [];
  const rendPct = data?.rendimento_pct ?? 0;
  const isUp = rendPct >= 0;
  const TrendIcon = isUp ? TrendingUp : TrendingDown;
  const trendColor = isUp ? "text-emerald-400" : "text-red-400";

  return (
    <Card variant="elevated" className="p-4 max-w-md">
      <div className="flex items-baseline justify-between mb-3">
        <div>
          <div className="text-xs text-foreground-muted">Patrimônio investido</div>
          <div className="text-2xl font-bold text-foreground">
            {fmtBRL(data?.total_current)}
          </div>
        </div>
        {data?.total_invested > 0 && (
          <div className={`flex items-center gap-1 ${trendColor} text-xs font-medium`}>
            <TrendIcon className="w-3.5 h-3.5" />
            {rendPct > 0 ? "+" : ""}
            {rendPct}%
          </div>
        )}
      </div>

      <div className="grid grid-cols-2 gap-3 text-xs mb-3">
        <div className="py-1.5 px-3 rounded-lg bg-surface-card-hover">
          <div className="text-[10px] text-foreground-muted">Aportado</div>
          <div className="text-foreground font-semibold">
            {fmtBRL(data?.total_invested)}
          </div>
        </div>
        <div className="py-1.5 px-3 rounded-lg bg-surface-card-hover">
          <div className="text-[10px] text-foreground-muted">Rendimento</div>
          <div className={`font-semibold ${trendColor}`}>
            {fmtBRL(data?.rendimento)}
          </div>
        </div>
      </div>

      {byClass.length > 0 && (
        <>
          <ResponsiveContainer width="100%" height={140}>
            <PieChart>
              <Pie
                data={byClass}
                dataKey="value"
                nameKey="name"
                outerRadius={55}
                innerRadius={32}
              >
                {byClass.map((c, i) => (
                  <Cell key={c.name} fill={COLORS[c.name] || `hsl(${i * 80}, 60%, 60%)`} />
                ))}
              </Pie>
              <Tooltip formatter={(v) => fmtBRL(v)} />
            </PieChart>
          </ResponsiveContainer>

          <div className="grid grid-cols-2 gap-x-3 gap-y-1 mt-1">
            {byClass.map((c) => (
              <div key={c.name} className="flex items-center gap-1.5 text-[10px]">
                <span
                  className="w-2 h-2 rounded-full"
                  style={{ background: COLORS[c.name] || "#94A3B8" }}
                />
                <span className="text-foreground-muted truncate">{c.name}</span>
                <span className="text-foreground ml-auto">{fmtBRL(c.value)}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </Card>
  );
}
